import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { Instagram, Facebook } from "lucide-react";

const columns = [
  {
    title: "DTA",
    links: [
      { to: "/about", label: "Our Story" },
      { to: "/support", label: "Find Support" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Customer",
    links: [
      { to: "/info/faq", label: "FAQ" },
      { to: "/info/delivery", label: "Delivery" },
      { to: "/info/returns", label: "Returns & Refunds" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/info/privacy", label: "Privacy Policy" },
      { to: "/info/cookies", label: "Cookie Policy" },
      { to: "/info/terms", label: "Terms & Conditions" },
      { to: "/info/mental-health", label: "Mental-Health Disclaimer" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white/70 border-t border-[rgba(255,255,255,0.06)]">
      <div className="dta-container py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-4">
            <LogoMark light />
            <p className="mt-6 text-sm max-w-xs leading-relaxed">
              Military heritage. Civilian resilience. <br />
              Failure is part of the process. Adjustment is how we move forward.
            </p>
            <div className="mt-8 flex items-center gap-5">
              <a
                href="https://instagram.com/downtestadjust"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="text-white/60 hover:text-white transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram strokeWidth={1.5} />
              </a>
              <a
                href="https://www.facebook.com/share/1He8znea9/?mibextid=wwXlfr"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="text-white/60 hover:text-white transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook strokeWidth={1.5} />
              </a>
              <a
                href="https://www.tiktok.com/@dta_downtestadjust"
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                className="text-white/60 hover:text-white transition-colors dta-overline text-[0.7rem]"
                data-testid="footer-tiktok"
              >
                TikTok
              </a>
            </div>
          </div>

          <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <div className="dta-overline text-white text-[0.7rem] mb-5">
                  {col.title}
                </div>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.to + l.label}>
                      <Link
                        to={l.to}
                        className="text-sm text-white/60 hover:text-white transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-[rgba(255,255,255,0.06)] mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} DTA. All rights reserved. British designed.
          </p>
          <p className="dta-overline text-[0.65rem] text-white/40">
            Down. Test. Adjust.
          </p>
        </div>
      </div>
    </footer>
  );
}
